export default {

  // 后台管理员列表
  getAccountList(params, success) {
    Request.GET('/account', params, response => success(response));
  },

  // 查询用户详情
  getAccountDetail(id, success) {
    Request.GET(`/account/${id}`, null, response => success(response));
  },

  // 删除用户
  deleteAccount(id, success) {
    Request.DEL(`/account/${id}`, null, response => success(response));
  },

  // 启用、禁用
  setAccountStatus(id, success) {
    Request.PUT(`/account/${id}/status`, null, response => success(response));
  },

  // 新增用户
  addAccount(params, success) {
    Request.POST('/account', params, response => success(response));
  },

  // 修改用户
  editAccount(id, params, success) {
    Request.PUT(`/account/${id}`, params, response => success(response));
  },
};



// WEBPACK FOOTER //
// ./src/api/accountApi.js